import { render, staticRenderFns } from "./r-smart-offer-bundle-expedition-group.vue?vue&type=template&id=32a157ca"
import script from "./r-smart-offer-bundle-expedition-group.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-expedition-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a157ca')) {
      api.createRecord('32a157ca', component.options)
    } else {
      api.reload('32a157ca', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-expedition-group.vue?vue&type=template&id=32a157ca", function () {
      api.rerender('32a157ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-expedition-group/r-smart-offer-bundle-expedition-group.vue"
export default component.exports